import { r as registerInstance, f as createEvent, h, e as Host, g as getElement } from './index-6c727dca.js';
import './component-errors-b6f1109b.js';
import { k as klassList } from './utils-c16d9285.js';

const epiOptionToggleCss = ":host{display:-ms-inline-flexbox;display:inline-flex;-ms-flex:0 1 auto;flex:0 1 auto;height:auto;width:auto;border:1px solid #808080;border-radius:6.1px;font-size:18px}@media (max-width: 720px){:host{font-size:16px}}@media screen and (max-width: 474px){:host{width:100%;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:space-evenly;justify-content:space-evenly;border:none}}:host(.has--popular){margin-bottom:22px}:host([disabled]){opacity:0.7;pointer-events:none}";

const EpiOptionToggle = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.epiValueChanged = createEvent(this, "epiValueChanged", 7);
    this.klassName = `epi-option-toggle`;
    this.hasPopular = [...this.el.querySelectorAll(`epi-toggle-choice`)].some(option => option.popular);
  }
  handleValueChange(newValue) {
    if (!newValue)
      return;
    const optionEls = [...this.el.querySelectorAll(`epi-toggle-choice`)];
    const selectableEl = optionEls.find(({ value }) => value === newValue);
    optionEls
      .filter(({ value }) => value !== newValue)
      .forEach(el => (el.selected = false));
    selectableEl && (selectableEl.selected = true);
    this.epiValueChanged.emit(newValue);
  }
  handleSelectionChange(ev) {
    this.value = ev.detail;
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender() { }
  // componentDidRender () { }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * @function render
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { class: klassList(this.klassName, this.hasPopular && `has--popular`) }, h("slot", { name: "option" })));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "value": ["handleValueChange"]
  }; }
};
EpiOptionToggle.style = epiOptionToggleCss;

export { EpiOptionToggle as epi_option_toggle };
